<!-- Names the dialog the overlay draws around this panel; the visible head is the operator, not a title. -->
<h2 class="cdk-visually-hidden" [attr.id]="headingId()">Account</h2>

<div class="umenu__head">
  @if (isUserLoading()) {
    <at-skeleton class="umenu__tile" />
    <at-skeleton class="umenu__name" />
    <at-skeleton class="umenu__email" />
  } @else {
    <!-- The same monogram tile as the row that opened this, at the same size: the menu reads as the
         profile row unfolding, not as a second component that happens to be about you. -->
    <span aria-hidden="true" class="umenu__tile">{{ initials() }}</span>
    <span class="umenu__name">{{ username() }}</span>
    <!-- An address is an identifier, so it wears the machine's face (The Mono Means Data Rule). -->
    <span class="umenu__email sa-mono">{{ email() }}</span>
  }
</div>

<ul class="umenu__list">
  <li>
    <a ariaCurrentWhenActive="page" routerLink="/profile" routerLinkActive="is-current">
      <at-icon aria-hidden="true">settings</at-icon>
      {{ dictionary.header.overlay.profile }}
    </a>
  </li>

  <li>
    <a ariaCurrentWhenActive="page" routerLink="/billing" routerLinkActive="is-current">
      <at-icon aria-hidden="true">credit_card</at-icon>
      Billing
    </a>
  </li>

  <!--
    The way back into the cookie consent dialog (AT-2749). Here rather than in the sidebar foot, which
    is the profile row and nothing else (DESIGN §8): this menu is that row unfolding, and it is also the
    phone header's account menu. It opens a dialog rather than a page, so it is a button, and it says so.
  -->
  <li>
    <button aria-haspopup="dialog" type="button" (click)="openCookieSettings()">
      <at-icon aria-hidden="true">cookie</at-icon>
      Cookie settings
    </button>
  </li>
</ul>

<!-- Leaving is not navigation. It sits below the rule, on its own. -->
<ul class="umenu__list umenu__list--exit">
  <li>
    <button type="button" (click)="logout.emit()">
      <at-icon aria-hidden="true">logout</at-icon>
      {{ dictionary.header.overlay.signOut }}
    </button>
  </li>
</ul>

<button class="cdk-visually-hidden" type="button" (click)="close.emit()">Close overlay</button>
